import { render, staticRenderFns } from "./NewsletterCheckboxes.vue?vue&type=template&id=061c9250&"
import script from "./NewsletterCheckboxes.vue?vue&type=script&lang=ts&"
export * from "./NewsletterCheckboxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports